import React from "react";
import { daysOfWeek, months, weekModifiers, offsetModifiers, daysCounter } from '../../../../../../../../resources/constants/dates';
import SelectOption from "../../../../../../../../interfaces/SelectOption";
import { DayOfWeek, WeekModifier, OffsetDirection } from "@appsinti/stats-utils/src/interfaces/SpecialRangeDatesConfig";
import styled from 'styled-components';
import useI18n from "@appsinti/i18n/useI18n";
import SpecialDropdown from "../../../../../components/SpecialDropdown";

const Label = styled.p`
  font: normal normal normal 14px/18px Montserrat;
  text-align: left;
  margin: auto;
  margin-left: 0px;
`;

const DropdownContainer = styled.div`
  max-width: 50%;
  width: fit-content;
  display: flex;
  align-items: center;
`;

const DropdownRow = styled.div`
  width: 100%;
  padding: 0px 5px;
  display: flex;
  justify-content: space-between;
`;

const translations = {
  offset: {en: 'Offset', es: 'Compensar'},
  the: {en: 'The', es: 'El'},
  day: {en: 'Day', es: 'Día'},
  month: {en: 'Month', es: 'Mes'},
  of: {en: 'of', es: 'de'}
}

const PatternRangeDateSection: React.FC<{
  weekModifier: SelectOption<WeekModifier>;
  dayOfWeek: SelectOption<DayOfWeek>;
  month: SelectOption<number>;
  offset: SelectOption<number>;
  offsetDirection: SelectOption<OffsetDirection>;
  setMonth: (month: SelectOption<number>) => void;
  setDayOfWeek: (dayOfWeek: SelectOption<DayOfWeek>) => void;
  setWeekModifier: (weekModifier: SelectOption<WeekModifier>) => void;
  setOffset: (days: SelectOption<number>) => void;  
  setOffsetDirection: (time: SelectOption<OffsetDirection>) => void;  
}> = ({ 
  weekModifier, 
  dayOfWeek, 
  month, 
  offset,
  offsetDirection,
  setMonth, 
  setDayOfWeek, 
  setWeekModifier,
  setOffset,
  setOffsetDirection }) => {

  const {translateObject, selectedLang} = useI18n();
  
  return (
    <>
      <DropdownRow>
        <Label>{translateObject(translations.offset)}</Label>
        <DropdownContainer>
          <SpecialDropdown  
            value={offset}
            options={daysCounter(selectedLang)}
            onChange={setOffset}
          />
        </DropdownContainer>
        <DropdownContainer>
          <SpecialDropdown  
            value={offsetDirection}
            options={offsetModifiers(selectedLang)}
            onChange={setOffsetDirection}
          />
        </DropdownContainer>
      </DropdownRow>
      <DropdownRow>
        <Label>{translateObject(translations.the)}</Label>

        <DropdownContainer>
          <SpecialDropdown  
            value={weekModifier}
            options={weekModifiers(selectedLang)}
            onChange={setWeekModifier}
          />
        </DropdownContainer>        
      </DropdownRow>
      
      <DropdownRow>
      <Label>{translateObject(translations.day)}</Label>
        <DropdownContainer>
          <SpecialDropdown  
            value={dayOfWeek}
            options={daysOfWeek(selectedLang)}
            onChange={setDayOfWeek}
          />
        </DropdownContainer>
      </DropdownRow>
      <DropdownRow>
        <Label>{translateObject(translations.month)}</Label>
        <DropdownContainer>
          <Label style={{marginRight: '5px'}}>{translateObject(translations.of)}</Label>
          <SpecialDropdown  
            value={month}
            options={months(selectedLang)}
            onChange={setMonth}
          />
        </DropdownContainer>
      </DropdownRow>
    </>
  );
};
export default PatternRangeDateSection;